/**
 * Map Editor Projects API Service
 */

import apiClient from '../client';
import API_CONFIG from '../../config/api.config';
import type {
  APIResponse,
  CreateProjectRequest,
  CreateProjectResponse,
  ListProjectResponse,
  UpdateProjectRequest,
  UpdateProjectResponse,
  DeleteProjectResponse,
} from '../types';

const { ENDPOINTS } = API_CONFIG;

/**
 * Map Editor Projects API
 */
export const mapEditorService = {
  /**
   * 프로젝트 생성
   * @param data - 프로젝트 생성 요청 데이터
   * @returns 생성된 프로젝트 정보
   */
  async createProject(
    data: CreateProjectRequest
  ): Promise<APIResponse<CreateProjectResponse>> {
    return apiClient.post<CreateProjectResponse>(
      ENDPOINTS.MAP_EDITOR.PROJECTS,
      data
    );
  },

  /**
   * 프로젝트 목록 조회
   * @param siteProjectId - 사이트 프로젝트 ID
   * @returns 프로젝트 목록
   */
  async getProjects(siteProjectId: number): Promise<APIResponse<ListProjectResponse>> {
    return apiClient.get<ListProjectResponse>(
      `${ENDPOINTS.MAP_EDITOR.PROJECTS}?site_project_id=${siteProjectId}`
    );
  },

  /**
   * 프로젝트 수정
   * @param id - 프로젝트 ID
   * @param data - 수정할 프로젝트 데이터
   * @returns 수정된 프로젝트 정보
   */
  async updateProject(
    id: number,
    data: UpdateProjectRequest
  ): Promise<APIResponse<UpdateProjectResponse>> {
    return apiClient.put<UpdateProjectResponse>(
      ENDPOINTS.MAP_EDITOR.PROJECT_BY_ID(id),
      data
    );
  },

  /**
   * 프로젝트 삭제 (소프트 삭제)
   * @param id - 프로젝트 ID
   * @returns 삭제 결과
   * @warning 프로젝트 삭제 시 연관된 모든 맵 데이터도 함께 삭제됩니다!
   */
  async deleteProject(id: number): Promise<APIResponse<DeleteProjectResponse>> {
    return apiClient.delete<DeleteProjectResponse>(
      ENDPOINTS.MAP_EDITOR.PROJECT_BY_ID(id)
    );
  },
};

export default mapEditorService;
